import React from 'react';
import { Clock } from 'lucide-react';
import NewsCard from './NewsCard';
import { formatPublishNp } from '../../utils/timeAgo';

function NewsRow({ item, onOpen }) {
  const parsePhotos = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const imageUrl = item.image || parsePhotos(item.photos)[0] || null;
  return (
    <article
      className="group flex gap-4 sm:gap-5 bg-white border border-line rounded-xl p-3 sm:p-4 cursor-pointer hover:border-crimson hover:shadow-sm transition-all"
      onClick={() => onOpen(item)}
      role="button"
      tabIndex={0}
    >
      <div className="w-28 h-20 sm:w-44 sm:h-28 flex-shrink-0 rounded-lg overflow-hidden bg-paper-tint">
        <img
          src={imageUrl || 'https://via.placeholder.com/400x300?text=Kalo+Jhola'}
          alt={item.title}
          loading="lazy"
          className="w-full h-full object-cover max-sm:object-contain transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <h3 className="font-display font-semibold text-[16.5px] sm:text-[18.5px] leading-snug mb-1.5 transition-colors group-hover:text-blue line-clamp-2">
          {item.title}
        </h3>
        {item.excerpt && (
          <p className="text-[14px] text-muted leading-relaxed mb-2 line-clamp-2 hidden sm:block">{item.excerpt}</p>
        )}
        <div className="flex items-center gap-1.5 text-xs text-muted mt-auto flex-wrap">
          <Clock size={12} />
          <span>{formatPublishNp(item.created_at || item.date)}</span>
          {item.read_time && (
            <>
              <span className="opacity-50">•</span>
              <span>{item.read_time} मिनेट पढाइ</span>
            </>
          )}
        </div>
      </div>
    </article>
  );
}

function NewsList({ news = [], view = 'grid', onOpen }) {
  if (!Array.isArray(news) || news.length === 0) return null;
  if (view === 'list') {
    return (
      <div className="flex flex-col gap-3 mb-10 w-full">
        {news.map((item) => (
          <NewsRow key={item.id} item={item} onOpen={onOpen} />
        ))}
      </div>
    );
  }
  return (
    <div className="grid gap-7 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-10 w-full">
      {news.map((item) => (
        <NewsCard key={item.id} item={item} onOpen={onOpen} />
      ))}
    </div>
  );
}

export default NewsList;